import { Link as ChakraLink, Flex, Image, Spacer } from '@chakra-ui/react';

import { tracking } from '#features/analytics';
import { Link } from '#features/routing';
import { Button } from '#features/ui';
import { BOT_INVITE_URL } from '../../data';

// Same "Teamplay LFG" logo the admin console header uses, so the landing and the
// dashboard read as one product surface.
const LFG_LOGO_SRC = 'https://media.teamplay.gg/assets/E7ZD/sOE.png';

const NAV_ITEMS = [
  { label: 'Features', href: '#features' },
  { label: 'Commands', href: '#commands' },
  { label: 'Games', href: '#games' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Community', href: '#community' },
];

/**
 * Dedicated landing header (the page sets `rendersOwnHeader`): LFG-bot branding +
 * section anchors instead of the consumer teamplay.gg app nav, styled like the
 * main site header (dark blur bar) so it still reads as the same family.
 */
export const BotHeader = () => (
  <Flex
    as="header"
    position="sticky"
    // No own margins: the page Stack pulls itself up under MainLayout's padding, so a
    // clean top=0 both places the bar flush at rest and keeps it flush when stuck.
    top={0}
    zIndex="sticky"
    w="100vw"
    ml="calc(50% - 50vw)"
    mr="calc(50% - 50vw)"
    bg="rgba(10, 10, 15, 0.88)"
    backdropFilter="blur(20px) saturate(130%)"
    borderBottomWidth="1px"
    borderColor="rgba(255, 255, 255, 0.08)"
  >
    <Flex
      w="100%"
      maxW={{ base: '640px', lg: '1200px' }}
      mx="auto"
      px={{ base: 4, md: 6, lg: 8 }}
      py={2.5}
      align="center"
      gap={4}
    >
      <Link to="/{-$locale}/discord-lfg-bot">
        <Image src={LFG_LOGO_SRC} alt="Teamplay LFG" h="30px" w="auto" />
      </Link>

      <Flex as="nav" gap={5} ml={4} display={{ base: 'none', lg: 'flex' }}>
        {NAV_ITEMS.map((item) => (
          <ChakraLink
            key={item.href}
            href={item.href}
            textStyle="title"
            color="fg.muted"
            _hover={{ color: 'fg', textDecoration: 'none' }}
          >
            {item.label}
          </ChakraLink>
        ))}
      </Flex>

      <Spacer />

      <Flex align="center" gap={2}>
        <Button
          asChild
          variant="ghost"
          size="sm"
          color="fg.muted"
          display={{ base: 'none', sm: 'inline-flex' }}
          onClick={() =>
            tracking.event({ action: 'header_dashboard', category: 'discord_bot_click' })
          }
          _hover={{ bg: 'whiteAlpha.50', color: 'fg.emphasized' }}
        >
          <Link to="/{-$locale}/discord-lfg-bot/admin">Dashboard</Link>
        </Button>
        <Button
          asChild
          size="sm"
          onClick={() => tracking.event({ action: 'header_invite', category: 'discord_bot_click' })}
        >
          <a href={BOT_INVITE_URL} target="_blank" rel="noopener noreferrer">
            Add to Discord
          </a>
        </Button>
      </Flex>
    </Flex>
  </Flex>
);
